import { render } from "./integrations.vue?vue&type=template&id=b8e114c4&lang=pug"
import script from "./integrations.vue?vue&type=script&setup=true&lang=js"
export * from "./integrations.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__